import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useT, THEME, pastelBtn } from './UI';

const API = '/api/ia-entrenamiento';
const token = () => localStorage.getItem('ri_token');
const headers = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + token() });

const FEEDBACK_LABEL = { buena: '✅ Buena', mala: '❌ Mala', corregida: '✏️ Corregida' };
const feedbackBg = (theme, feedback) => feedback === 'buena' ? pastelBtn(theme,'green').background : feedback === 'mala' ? pastelBtn(theme,'red').background : feedback === 'corregida' ? pastelBtn(theme,'amber').background : theme.surface;

function SimuladorChat({ onGuardado }) {
  const theme = useT();
  const [nombre, setNombre] = useState('');
  const [input, setInput] = useState('');
  const [mensajes, setMensajes] = useState([]);
  const [estado, setEstado] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [yaAvisado, setYaAvisado] = useState(false);
  const [forzarAbierto, setForzarAbierto] = useState('auto');
  const [forzarModo, setForzarModo] = useState('auto');
  const [modoReal, setModoReal] = useState(false);
  const bottomRef = useRef(null);
  const chatRef = useRef(null);

  useEffect(() => {
    if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [mensajes]);

  const enviar = async () => {
    const texto = input.trim();
    if (!texto || cargando) return;
    setInput('');
    setMensajes(prev => [...prev, { role: 'user', texto }]);
    setCargando(true);
    try {
      const r = await fetch(`${API}/simular`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({
          mensaje: texto,
          nombre: nombre.trim() || null,
          forzarAbierto: forzarAbierto !== 'auto' ? forzarAbierto === 'abierto' : undefined,
          forzarModo: forzarModo !== 'auto' ? forzarModo : undefined,
          yaAvisado,
        })
      });
      const data = await r.json();
      setEstado({ abierto: data.abierto, horaActual: data.horaActual, diaActual: data.diaActual, iaModo: data.iaModo, nEjemplos: data.nEjemplos });
      // Si se envió aviso de cierre, marcarlo para los siguientes mensajes
      if (data.mensajesEnviados?.some(m => m.tipo === 'cierre')) setYaAvisado(true);
      // Modo real → mensaje completo de Baileys; Entrenamiento → solo respuesta IA
      const textoBaileys = data.mensajesEnviados?.length > 0
        ? data.mensajesEnviados.map(m => m.texto).join('\n\n')
        : null;
      const textoIA = data.respuestaIA || null;
      setMensajes(prev => [...prev, {
        role: 'bot',
        texto: modoReal ? textoBaileys : textoIA,
        iaId: data.iaId || null,
        confianza: data.confianza,
        confidence: data.confidence,
        respuestaIA: data.respuestaIA,
        corrigiendo: false,
        correccion: '',
        guardado: false,
        modoReal,
      }]);
    } catch(e) {
      setMensajes(prev => [...prev, { role: 'bot', texto: null, error: true }]);
    }
    setCargando(false);
  };

  const guardarCorreccion = async (idx, correccion) => {
    const msg = mensajes[idx];
    if (!msg.iaId) return;
    await fetch(`${API}/feedback`, {
      method: 'POST', headers: headers(),
      body: JSON.stringify({ id: msg.iaId, feedback: 'corregida', correccion })
    });
    setMensajes(prev => prev.map((m, i) => i === idx ? { ...m, corrigiendo: false, correccion, guardado: true } : m));
    if (onGuardado) onGuardado();
  };

  const marcarNoResponder = async (idx) => {
    const msg = mensajes[idx];
    if (!msg.iaId) return;
    await fetch(`${API}/toggle-no-responder/${msg.iaId}`, { method: 'POST', headers: headers() });
    setMensajes(prev => prev.map((m, i) => i === idx ? { ...m, guardado: true, guardadoLabel: '🚫 Marcado: no responder' } : m));
    if (onGuardado) onGuardado();
  };

  const marcarSiempre = async (idx) => {
    const msg = mensajes[idx];
    if (!msg.iaId) return;
    await fetch(`${API}/toggle-responder-siempre/${msg.iaId}`, { method: 'POST', headers: headers() });
    setMensajes(prev => prev.map((m, i) => i === idx ? { ...m, guardado: true, guardadoLabel: '⚡ Marcado: responder siempre' } : m));
    if (onGuardado) onGuardado();
  };

  const limpiar = () => { setMensajes([]); setEstado(null); setYaAvisado(false); };

  return (
    <div style={{ border: `2px solid ${theme.primary}`, borderRadius: 12, marginBottom: 20, background: theme.surface2, overflow: 'hidden' }}>
      {/* Cabecera */}
      <div style={{ background: theme.primary, padding: '12px 18px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <span style={{ color: theme===THEME.dark ? '#0b0b09' : '#fff', fontWeight: 700, fontSize: 14 }}>🧪 Chat de prueba</span>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre cliente" style={{ padding: '5px 10px', borderRadius: 6, border: 'none', fontSize: 12, width: 130 }} />
            {mensajes.length > 0 && <button onClick={limpiar} style={{ background: theme===THEME.dark ? 'rgba(11,11,9,.2)' : 'rgba(255,255,255,.2)', border: 'none', borderRadius: 6, color: theme===THEME.dark ? '#0b0b09' : '#fff', fontSize: 11, padding: '5px 10px', cursor: 'pointer' }}>Limpiar</button>}
          </div>
        </div>
        {/* Controles de simulación */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ color: theme===THEME.dark ? 'rgba(11,11,9,.65)' : '#bfdbfe', fontSize: 11, fontWeight: 600 }}>Tienda:</span>
          {[['auto', '⏱ Real'], ['abierto', '🟢 Abierta'], ['cerrado', '🔴 Cerrada']].map(([v, label]) => (
            <button key={v} onClick={() => setForzarAbierto(v)} style={{
              padding: '3px 10px', borderRadius: 20, border: 'none', fontSize: 11, cursor: 'pointer', fontWeight: forzarAbierto === v ? 700 : 400,
              background: forzarAbierto === v ? (theme===THEME.dark ? theme.bg : '#fff') : (theme===THEME.dark ? 'rgba(11,11,9,.15)' : 'rgba(255,255,255,.15)'),
              color: forzarAbierto === v ? theme.primary : (theme===THEME.dark ? 'rgba(11,11,9,.65)' : '#e0e7ff'),
            }}>{label}</button>
          ))}
          <span style={{ color: theme===THEME.dark ? 'rgba(11,11,9,.65)' : '#bfdbfe', fontSize: 11, fontWeight: 600, marginLeft: 8 }}>Modo IA:</span>
          {[['auto', '⏱ Real'], ['nunca', '🔇 Nunca'], ['fuera_horario', '🌙 Fuera horario'], ['siempre', '🤖 Siempre']].map(([v, label]) => (
            <button key={v} onClick={() => setForzarModo(v)} style={{
              padding: '3px 10px', borderRadius: 20, border: 'none', fontSize: 11, cursor: 'pointer', fontWeight: forzarModo === v ? 700 : 400,
              background: forzarModo === v ? (theme===THEME.dark ? theme.bg : '#fff') : (theme===THEME.dark ? 'rgba(11,11,9,.15)' : 'rgba(255,255,255,.15)'),
              color: forzarModo === v ? theme.primary : (theme===THEME.dark ? 'rgba(11,11,9,.65)' : '#e0e7ff'),
            }}>{label}</button>
          ))}
          <label style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', userSelect: 'none' }}>
            <input type="checkbox" checked={modoReal} onChange={e => { setModoReal(e.target.checked); limpiar(); }} style={{ accentColor: '#fbbf24' }} />
            <span style={{ fontSize: 11, color: modoReal ? '#fbbf24' : (theme===THEME.dark ? 'rgba(11,11,9,.65)' : '#bfdbfe'), fontWeight: modoReal ? 700 : 400 }}>
              {modoReal ? '⚡ Modo real' : '🧪 Modo entrenamiento'}
            </span>
          </label>
          {estado && (
            <span style={{ fontSize: 11, color: theme===THEME.dark ? 'rgba(11,11,9,.65)' : '#bfdbfe' }}>
              {estado.diaActual} {estado.horaActual} · {estado.nEjemplos} ejemplos
            </span>
          )}
        </div>
      </div>

      {/* Área de chat */}
      <div ref={chatRef} style={{ minHeight: 220, maxHeight: 420, overflowY: 'auto', padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {mensajes.length === 0 && (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color:theme.faint, fontSize: 13, textAlign: 'center', padding: '40px 0' }}>
            Escribe un mensaje como si fueras un cliente<br />y verás cómo respondería el asistente.
          </div>
        )}

        {mensajes.map((m, i) => (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
            {m.role === 'user' ? (
              <div style={{ background: theme.primary, color: theme===THEME.dark ? '#0b0b09' : '#fff', borderRadius: '16px 16px 4px 16px', padding: '9px 14px', fontSize: 13, maxWidth: '70%' }}>
                {m.texto}
              </div>
            ) : (
              <div style={{ maxWidth: '80%' }}>
                {m.error ? (
                  <div style={{ ...pastelBtn(theme,'red'), borderRadius: '16px 16px 16px 4px', padding: '9px 14px', fontSize: 13 }}>Error al conectar con el servidor.</div>
                ) : m.texto ? (
                  <div>
                    <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius: '16px 16px 16px 4px', padding: '9px 14px', fontSize: 13, color:theme.ink, whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                      {m.texto}
                    </div>
                    {!m.confianza && m.respuestaIA === null && (
                      <div style={{ fontSize: 11, ...pastelBtn(theme,'amber'), border:'none', borderRadius: 6, padding: '3px 8px', marginTop: 4, display: 'inline-block' }}>⚠️ Sin confianza — se envió solo aviso de horario</div>
                    )}
                  </div>
                ) : (
                  <div style={{ background:theme.surface2, borderRadius: '16px 16px 16px 4px', padding: '9px 14px', fontSize: 13, color:theme.muted }}>
                    🔇 No se enviaría nada con la configuración actual.
                  </div>
                )}

                {/* Nivel de confianza */}
                {m.confidence != null && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 5 }}>
                    <span style={{ fontSize: 10, color:theme.faint }}>Confianza:</span>
                    {[1,2,3,4,5].map(n => (
                      <span key={n} style={{ fontSize: 14, lineHeight: 1, filter: n <= m.confidence ? 'none' : 'grayscale(1) opacity(0.3)' }}>
                        {m.confidence >= 4 ? '🟢' : m.confidence >= 3 ? '🟡' : '🔴'}
                      </span>
                    )).slice(0, 5).map((el, i) => (
                      <span key={i} style={{ fontSize: 12, color: i < m.confidence ? (m.confidence >= 4 ? '#16a34a' : m.confidence >= 3 ? '#d97706' : '#dc2626') : theme.border }}>●</span>
                    ))}
                    <span style={{ fontSize: 11, fontWeight: 700, color: m.confidence >= 4 ? '#16a34a' : m.confidence >= 3 ? '#d97706' : '#dc2626' }}>{m.confidence}/5</span>
                  </div>
                )}

                {/* Acciones de corrección — solo en modo entrenamiento */}
                {m.iaId && !m.guardado && !m.modoReal && (
                  <div style={{ marginTop: 6 }}>
                    {m.corrigiendo ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                        <textarea
                          value={m.correccion}
                          onChange={e => setMensajes(prev => prev.map((x, j) => j === i ? { ...x, correccion: e.target.value } : x))}
                          placeholder="¿Cómo debería haber respondido?"
                          rows={3}
                          style={{ width: '100%', padding: 8, borderRadius: 8, border:`1px solid ${theme.borderStrong}`, fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }}
                        />
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button onClick={() => guardarCorreccion(i, m.correccion)} style={{ padding: '5px 12px', borderRadius: 6, background: '#eab308', color: '#1c1400', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>💾 Guardar y entrenar</button>
                          <button onClick={() => setMensajes(prev => prev.map((x, j) => j === i ? { ...x, corrigiendo: false } : x))} style={{ padding: '5px 12px', borderRadius: 6, background:theme.surface2, color:theme.body, border: 'none', cursor: 'pointer', fontSize: 12 }}>Cancelar</button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
                        <button onClick={() => guardarCorreccion(i, '')} style={{ padding: '3px 10px', borderRadius: 6, ...pastelBtn(theme,'green'), border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>✅ Buena</button>
                        <button onClick={() => setMensajes(prev => prev.map((x, j) => j === i ? { ...x, corrigiendo: true } : x))} style={{ padding: '3px 10px', borderRadius: 6, ...pastelBtn(theme,'amber'), border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>✏️ Corregir</button>
                        <button onClick={() => marcarSiempre(i)} style={{ padding: '3px 10px', borderRadius: 6, ...pastelBtn(theme,'amber'), border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>⚡ Siempre</button>
                        <button onClick={() => marcarNoResponder(i)} style={{ padding: '3px 10px', borderRadius: 6, ...pastelBtn(theme,'red'), border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>🚫 No responder</button>
                      </div>
                    )}
                  </div>
                )}
                {m.guardado && (
                  <div style={{ fontSize: 11, color: m.guardadoLabel ? (theme===THEME.dark?'#fca5a5':'#dc2626') : (theme===THEME.dark?'#6ee7b7':'#15803d'), marginTop: 4 }}>{m.guardadoLabel || '✅ Guardado como entrenamiento'}</div>
                )}
              </div>
            )}
          </div>
        ))}

        {cargando && (
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius: '16px 16px 16px 4px', padding: '10px 16px', fontSize: 13, color:theme.faint }}>
              <span style={{ display: 'inline-block', animation: 'pulse 1s infinite' }}>⏳ Pensando...</span>
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div style={{ borderTop: `1px solid ${theme.border}`, padding: '12px 18px', display: 'flex', gap: 8, background:theme.surface }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && !e.shiftKey && enviar()}
          placeholder="Escribe como si fueras el cliente..."
          disabled={cargando}
          style={{ flex: 1, padding: '9px 14px', borderRadius: 20, border:`1px solid ${theme.borderStrong}`, fontSize: 13, outline: 'none', background:theme.surface, color:theme.ink }}
        />
        <button onClick={enviar} disabled={cargando || !input.trim()} style={{ padding: '9px 20px', borderRadius: 20, background: theme.primary, color: theme===THEME.dark ? '#0b0b09' : '#fff', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 13, opacity: cargando || !input.trim() ? .5 : 1 }}>
          Enviar
        </button>
      </div>
    </div>
  );
}

export default function EntrenamientoIA() {
  const theme = useT();
  const [registros, setRegistros] = useState([]);
  const [iaModo, setIaModo] = useState('nunca');
  const [cambiandoModo, setCambiandoModo] = useState(false);
  const [editando, setEditando] = useState(null);
  const [correccion, setCorreccion] = useState('');
  const [filtro, setFiltro] = useState('todos');
  const [verEjemplos, setVerEjemplos] = useState(false);
  const [verNoResponder, setVerNoResponder] = useState(false);
  const [verSiempre, setVerSiempre] = useState(false);
  const [verBorde, setVerBorde] = useState(false);
  const [bordes, setBordes] = useState([]);

  const cargar = useCallback(async () => {
    const r = await fetch(API, { headers: headers() });
    const data = await r.json();
    setRegistros(data.registros || []);
    setIaModo(data.iaModo || 'nunca');
  }, []);

  const cargarBordes = useCallback(async () => {
    const r = await fetch('/api/paco-borde', { headers: headers() });
    setBordes(await r.json());
  }, []);

  const toggleBorde = async (jid, nombre) => {
    const existe = bordes.find(b => b.jid === jid);
    if (existe) {
      await fetch(`/api/paco-borde/${existe.id}`, { method: 'DELETE', headers: headers() });
    } else {
      await fetch('/api/paco-borde', { method: 'POST', headers: headers(), body: JSON.stringify({ jid, nombre }) });
    }
    cargarBordes();
  };

  useEffect(() => { cargar(); cargarBordes(); }, [cargar, cargarBordes]);

  const cambiarModo = async (modo) => {
    setCambiandoModo(true);
    await fetch(`${API}/modo-ia`, { method: 'POST', headers: headers(), body: JSON.stringify({ modo }) });
    setIaModo(modo);
    setCambiandoModo(false);
  };

  const toggleEjemplo = async (id) => {
    await fetch(`${API}/toggle-ejemplo/${id}`, { method: 'POST', headers: headers() });
    cargar();
  };

  const toggleNoResponder = async (id) => {
    await fetch(`${API}/toggle-no-responder/${id}`, { method: 'POST', headers: headers() });
    cargar();
  };

  const toggleResponderSiempre = async (id) => {
    await fetch(`${API}/toggle-responder-siempre/${id}`, { method: 'POST', headers: headers() });
    cargar();
  };

  const darFeedback = async (id, feedback, texto) => {
    await fetch(`${API}/feedback`, {
      method: 'POST', headers: headers(),
      body: JSON.stringify({ id, feedback, correccion: texto || null })
    });
    setEditando(null);
    cargar();
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este registro?')) return;
    await fetch(`${API}/${id}`, { method: 'DELETE', headers: headers() });
    cargar();
  };

  const ejemplosAprobados = registros.filter(r => r.usar_ejemplo);
  const ejemplosNoResponder = registros.filter(r => r.no_responder);
  const ejemplosSiempre = registros.filter(r => r.responder_siempre);

  const filtrados = registros.filter(r =>
    filtro === 'todos' ? true :
    filtro === 'pendientes' ? !r.feedback :
    filtro === 'fuera_horario' ? r.fuera_horario :
    filtro === 'aprobados' ? r.usar_ejemplo :
    r.feedback === filtro
  );

  const stats = {
    total: registros.length,
    pendientes: registros.filter(r => !r.feedback).length,
    buenas: registros.filter(r => r.feedback === 'buena').length,
    malas: registros.filter(r => r.feedback === 'mala').length,
    corregidas: registros.filter(r => r.feedback === 'corregida').length,
    fueraHorario: registros.filter(r => r.fuera_horario).length,
    aprobados: ejemplosAprobados.length,
  };

  return (
    <div style={{ padding: '24px', maxWidth: 900, margin: '0 auto' }}>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color:theme.ink, margin: 0 }}>🤖 PACO</h2>
        <p style={{ color:theme.muted, fontSize: 13, marginTop: 4 }}>
          Revisa las respuestas que daría la IA. Marca como referencia las que quieras que use al responder automáticamente.
        </p>
      </div>

      {/* Selector modo IA */}
      {(() => {
        const modos = [
          { key: 'nunca', icon: '🔇', label: 'Nunca', desc: 'La IA no responde. Solo se registran los mensajes para entrenamiento.' },
          { key: 'fuera_horario', icon: '🌙', label: 'Solo fuera de horario', desc: 'Si la IA tiene confianza, responde cuando la tienda está cerrada.' },
          { key: 'siempre', icon: '🤖', label: 'Siempre', desc: 'La IA responde en todo momento cuando tiene confianza suficiente.' },
        ];
        return (
          <div style={{ border:`1px solid ${theme.border}`, borderRadius: 12, padding: '14px 18px', marginBottom: 12, background:theme.surface2 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color:theme.ink, marginBottom: 10 }}>🤖 Cuándo responde la IA</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {modos.map(m => (
                <button key={m.key} onClick={() => cambiarModo(m.key)} disabled={cambiandoModo} style={{
                  flex: 1, minWidth: 160, padding: '10px 14px', borderRadius: 10, cursor: 'pointer', textAlign: 'left',
                  border: `2px solid ${iaModo === m.key ? theme.primary : theme.border}`,
                  background: iaModo === m.key ? theme.primaryBg : theme.surface,
                  transition: 'all .15s',
                }}>
                  <div style={{ fontSize: 15, marginBottom: 3 }}>{m.icon} <span style={{ fontWeight: 700, fontSize: 13, color: iaModo === m.key ? theme.primary : theme.ink }}>{m.label}</span></div>
                  <div style={{ fontSize: 11, color:theme.muted, lineHeight: 1.4 }}>{m.desc}</div>
                </button>
              ))}
            </div>
          </div>
        );
      })()}

      <SimuladorChat onGuardado={cargar} />

      {/* Sección ejemplos aprobados */}
      <div style={{ border:`1px solid ${theme.border}`, borderRadius: 12, marginBottom: 20, overflow: 'hidden' }}>
        <button onClick={() => setVerEjemplos(v => !v)} style={{
          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 18px', background:theme.surface2, border: 'none', cursor: 'pointer', textAlign: 'left',
        }}>
          <span style={{ fontWeight: 700, fontSize: 14, color:theme.ink }}>
            ✅ Ejemplos aprobados como referencia
            <span style={{ marginLeft: 8, background: ejemplosAprobados.length > 0 ? pastelBtn(theme,'green').background : theme.surface2, color: ejemplosAprobados.length > 0 ? pastelBtn(theme,'green').color : theme.muted, borderRadius: 20, fontSize: 11, fontWeight: 700, padding: '2px 8px' }}>
              {ejemplosAprobados.length}
            </span>
          </span>
          <span style={{ color:theme.faint, fontSize: 12 }}>{verEjemplos ? '▲ Ocultar' : '▼ Ver'}</span>
        </button>
        {verEjemplos && (
          <div style={{ padding: '12px 18px', borderTop:`1px solid ${theme.border}` }}>
            {ejemplosAprobados.length === 0 ? (
              <div style={{ color:theme.faint, fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
                Ningún ejemplo marcado aún. Usa el checkbox en los registros para aprobarlos.
              </div>
            ) : ejemplosAprobados.map(r => (
              <div key={r.id} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '10px 0', borderBottom:`1px solid ${theme.border}` }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, color:theme.body, fontWeight: 600, marginBottom: 3 }}>
                    💬 {r.mensaje}
                    {!!r.ejemplo_auto && (
                      <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, color: theme.faint, border: `1px solid ${theme.border}`, borderRadius: 10, padding: '1px 6px' }} title="Detectado automáticamente de una respuesta humana por WhatsApp">
                        auto
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: 12, ...pastelBtn(theme,'blue'), border:'none', borderRadius: 6, padding: '4px 8px' }}>
                    {r.correccion || r.respuesta}
                  </div>
                </div>
                <button onClick={() => toggleEjemplo(r.id)} title="Quitar de referencia" style={{
                  ...pastelBtn(theme,'red'), border: 'none', borderRadius: 6, padding: '4px 10px',
                  fontSize: 11, cursor: 'pointer', fontWeight: 600, flexShrink: 0,
                }}>
                  Desactivar
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Sección responder siempre */}
      <div style={{ border:`1px solid ${pastelBtn(theme,'amber').border.split(' ').pop()}`, borderRadius: 12, marginBottom: 20, overflow: 'hidden' }}>
        <button onClick={() => setVerSiempre(v => !v)} style={{
          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 18px', background: pastelBtn(theme,'amber').background, border: 'none', cursor: 'pointer', textAlign: 'left',
        }}>
          <span style={{ fontWeight: 700, fontSize: 14, color:theme.ink }}>
            ⚡ Responder siempre (abierto y cerrado)
            <span style={{ marginLeft: 8, ...(ejemplosSiempre.length > 0 ? pastelBtn(theme,'amber') : { background:theme.surface2, color:theme.muted }), border:'none', borderRadius: 20, fontSize: 11, fontWeight: 700, padding: '2px 8px' }}>
              {ejemplosSiempre.length}
            </span>
          </span>
          <span style={{ color:theme.faint, fontSize: 12 }}>{verSiempre ? '▲ Ocultar' : '▼ Ver'}</span>
        </button>
        {verSiempre && (
          <div style={{ padding: '12px 18px', borderTop:`1px solid ${pastelBtn(theme,'amber').border.split(' ').pop()}` }}>
            {ejemplosSiempre.length === 0 ? (
              <div style={{ color:theme.faint, fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
                Ningún ejemplo marcado como "siempre responder" todavía.<br />
                <span style={{ fontSize: 12 }}>Ideal para preguntas de horario, ubicación, precios…</span>
              </div>
            ) : ejemplosSiempre.map(r => (
              <div key={r.id} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '10px 0', borderBottom:`1px solid ${theme.border}` }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, color:theme.body, fontWeight: 600, marginBottom: 3 }}>💬 {r.mensaje}</div>
                  <div style={{ fontSize: 12, ...pastelBtn(theme,'amber'), border:'none', borderRadius: 6, padding: '4px 8px' }}>
                    {r.correccion || r.respuesta}
                  </div>
                </div>
                <button onClick={() => toggleResponderSiempre(r.id)} title="Quitar marca" style={{
                  background:theme.surface2, border: 'none', borderRadius: 6, padding: '4px 10px',
                  color:theme.body, fontSize: 11, cursor: 'pointer', fontWeight: 600, flexShrink: 0,
                }}>
                  Desactivar
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Sección no responder */}
      <div style={{ border:`1px solid ${pastelBtn(theme,'red').border.split(' ').pop()}`, borderRadius: 12, marginBottom: 20, overflow: 'hidden' }}>
        <button onClick={() => setVerNoResponder(v => !v)} style={{
          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 18px', background: pastelBtn(theme,'red').background, border: 'none', cursor: 'pointer', textAlign: 'left',
        }}>
          <span style={{ fontWeight: 700, fontSize: 14, color:theme.ink }}>
            🚫 Mensajes marcados como "no responder"
            <span style={{ marginLeft: 8, ...(ejemplosNoResponder.length > 0 ? pastelBtn(theme,'red') : { background:theme.surface2, color:theme.muted }), border:'none', borderRadius: 20, fontSize: 11, fontWeight: 700, padding: '2px 8px' }}>
              {ejemplosNoResponder.length}
            </span>
          </span>
          <span style={{ color:theme.faint, fontSize: 12 }}>{verNoResponder ? '▲ Ocultar' : '▼ Ver'}</span>
        </button>
        {verNoResponder && (
          <div style={{ padding: '12px 18px', borderTop:`1px solid ${pastelBtn(theme,'red').border.split(' ').pop()}` }}>
            {ejemplosNoResponder.length === 0 ? (
              <div style={{ color:theme.faint, fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
                Ningún mensaje marcado como "no responder" todavía.
              </div>
            ) : ejemplosNoResponder.map(r => (
              <div key={r.id} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '10px 0', borderBottom:`1px solid ${theme.border}` }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, color:theme.body, fontWeight: 600, marginBottom: 3 }}>💬 {r.mensaje}</div>
                  <div style={{ fontSize: 11, color:theme.faint }}>De {r.remitente}{r.telefono ? <span style={{ marginLeft: 6, fontFamily: 'monospace', color:theme.muted }}>· {r.telefono}</span> : null} · {new Date(r.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</div>
                </div>
                <button onClick={() => toggleNoResponder(r.id)} title="Quitar marca" style={{
                  background:theme.surface2, border: 'none', borderRadius: 6, padding: '4px 10px',
                  color:theme.body, fontSize: 11, cursor: 'pointer', fontWeight: 600, flexShrink: 0,
                }}>
                  Desactivar
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* PACO Borde */}
      <div style={{ border:`1px solid ${pastelBtn(theme,'amber').border.split(' ').pop()}`, borderRadius: 10, marginBottom: 16, overflow: 'hidden' }}>
        <button onClick={() => setVerBorde(v => !v)} style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', background: pastelBtn(theme,'amber').background, border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 13, color: pastelBtn(theme,'amber').color }}>
          <span>😈 PACO Borde <span style={{ marginLeft: 8, ...(bordes.length > 0 ? pastelBtn(theme,'amber') : { background:theme.surface2, color:theme.muted }), border:'none', borderRadius: 20, fontSize: 11, fontWeight: 700, padding: '2px 8px' }}>{bordes.length}</span></span>
          <span style={{ color:theme.faint, fontSize: 12 }}>{verBorde ? '▲ Ocultar' : '▼ Ver'}</span>
        </button>
        {verBorde && (
          <div style={{ padding: '12px 18px', borderTop:`1px solid ${pastelBtn(theme,'amber').border.split(' ').pop()}` }}>
            <p style={{ fontSize: 12, color:theme.body, marginBottom: 12 }}>Estos contactos reciben frases sarcásticas de PACO en cada mensaje, sin pasar por Ollama. Márcalos desde el botón 😈 de cada mensaje.</p>
            {bordes.length === 0
              ? <div style={{ color:theme.faint, fontSize: 13, textAlign: 'center', padding: '12px 0' }}>Ningún contacto marcado como borde.</div>
              : bordes.map(b => (
                <div key={b.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom:`1px solid ${theme.border}` }}>
                  <div>
                    <span style={{ fontWeight: 600, fontSize: 13, color:theme.ink }}>{b.nombre || '(sin nombre)'}</span>
                    <span style={{ marginLeft: 8, fontSize: 11, color:theme.muted, fontFamily: 'monospace' }}>{b.jid}</span>
                  </div>
                  <button onClick={() => toggleBorde(b.jid, b.nombre)} style={{ padding: '3px 10px', borderRadius: 6, ...pastelBtn(theme,'red'), border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>Quitar</button>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* Stats */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        {[
          { label: 'Total', valor: stats.total, color: 'purple' },
          { label: 'Pendientes', valor: stats.pendientes, color: 'amber' },
          { label: 'Buenas', valor: stats.buenas, color: 'green' },
          { label: 'Malas', valor: stats.malas, color: 'red' },
          { label: 'Corregidas', valor: stats.corregidas, color: 'amber' },
          { label: 'Fuera horario', valor: stats.fueraHorario, color: 'purple' },
          { label: 'Aprobados', valor: stats.aprobados, color: 'green' },
        ].map(s => (
          <div key={s.label} style={{ background: pastelBtn(theme,s.color).background, borderRadius: 10, padding: '10px 18px', textAlign: 'center', minWidth: 80 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color:theme.ink }}>{s.valor}</div>
            <div style={{ fontSize: 11, color:theme.muted, marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {[
          { key: 'todos', label: 'Todos' },
          { key: 'pendientes', label: 'Pendientes' },
          { key: 'buena', label: FEEDBACK_LABEL.buena },
          { key: 'mala', label: FEEDBACK_LABEL.mala },
          { key: 'corregida', label: FEEDBACK_LABEL.corregida },
          { key: 'fuera_horario', label: '🌙 Fuera de horario' },
          { key: 'aprobados', label: '✅ Aprobados' },
        ].map(f => (
          <button key={f.key} onClick={() => setFiltro(f.key)} style={{
            padding: '5px 12px', borderRadius: 6, border:`1px solid ${theme.borderStrong}`, fontSize: 12, cursor: 'pointer',
            background: filtro === f.key ? theme.primary : theme.surface2, color: filtro === f.key ? '#fff' : theme.body, fontWeight: filtro === f.key ? 700 : 400
          }}>{f.label}</button>
        ))}
      </div>

      {/* Lista */}
      {filtrados.length === 0 ? (
        <div style={{ textAlign: 'center', color:theme.faint, padding: 60, fontSize: 14 }}>
          No hay registros{filtro !== 'todos' ? ' con este filtro' : ''}.<br />
          <span style={{ fontSize: 12 }}>Los mensajes de WhatsApp aparecerán aquí automáticamente.</span>
        </div>
      ) : filtrados.map(r => (
        <div key={r.id} style={{
          background: feedbackBg(theme, r.feedback),
          border: r.usar_ejemplo ? pastelBtn(theme,'green').border : `1px solid ${theme.border}`,
          borderRadius: 12, padding: 16, marginBottom: 12,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color:theme.muted }}>📱 {r.remitente}{r.telefono ? <span style={{ marginLeft: 6, fontFamily: 'monospace', fontWeight: 400 }}>{r.telefono}</span> : null}</span>
              <span style={{ fontSize: 11, color:theme.faint }}>
                {new Date(r.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
              </span>
              {r.fuera_horario ? <span style={{ fontSize: 11, fontWeight: 700, ...pastelBtn(theme,'purple'), border:'none', borderRadius: 6, padding: '2px 7px' }}>🌙 Fuera de horario</span> : null}
              {r.feedback && <span style={{ fontSize: 11, fontWeight: 700, color:theme.body }}>{FEEDBACK_LABEL[r.feedback]}</span>}
              {r.respuesta === 'NODECISION' && <span style={{ fontSize: 11, fontWeight: 700, ...pastelBtn(theme,'amber'), border:'none', borderRadius: 6, padding: '2px 7px' }}>⚠️ Sin confianza</span>}
              {r.responder_siempre ? <span style={{ fontSize: 11, fontWeight: 700, ...pastelBtn(theme,'amber'), border:'none', borderRadius: 6, padding: '2px 7px' }}>⚡ Siempre</span> : null}
              {r.no_responder ? <span style={{ fontSize: 11, fontWeight: 700, ...pastelBtn(theme,'red'), border:'none', borderRadius: 6, padding: '2px 7px' }}>🚫 No responder</span> : null}
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              {(r.jid || r.telefono) && (() => { const idBorde = r.jid || r.telefono; const esBorde = bordes.some(b => b.jid === idBorde); return (
                <button onClick={() => toggleBorde(idBorde, r.remitente)} style={{ padding: '2px 8px', borderRadius: 6, ...(esBorde ? pastelBtn(theme,'amber') : { background:theme.surface2, color:theme.faint }), border:'none', cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>
                  {esBorde ? '😈 Borde ✓' : '😈'}
                </button>
              ); })()}
              <button onClick={() => eliminar(r.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color:theme.faint, fontSize: 16 }}>✕</button>
            </div>
          </div>

          {/* Mensaje cliente */}
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color:theme.body, marginBottom: 4 }}>💬 CLIENTE</div>
            <div style={{ background:theme.surface2, borderRadius: 8, padding: '8px 12px', fontSize: 13, color:theme.ink }}>{r.mensaje}</div>
          </div>

          {/* Respuesta IA */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color:theme.body, marginBottom: 4 }}>🤖 RESPUESTA IA</div>
            <div style={{ ...pastelBtn(theme, r.respuesta === 'NODECISION' ? 'amber' : r.respuesta?.startsWith('[PACO]') ? 'green' : 'blue'), border:'none', borderRadius: 8, padding: '8px 12px', fontSize: 13, borderLeft: `3px solid ${r.respuesta === 'NODECISION' ? '#eab308' : r.respuesta?.startsWith('[PACO]') ? '#16a34a' : theme.primary}` }}>
              {r.respuesta === 'NODECISION' ? 'La IA no tenía suficiente confianza para responder.' : r.respuesta?.startsWith('[PACO]') ? <span>🎭 <em>PACO envió:</em> {r.respuesta.replace('[PACO] ', '')}</span> : r.respuesta}
            </div>
          </div>

          {/* Corrección si existe */}
          {r.correccion && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color:theme.body, marginBottom: 4 }}>✏️ TU CORRECCIÓN</div>
              <div style={{ ...pastelBtn(theme,'amber'), border:'none', borderRadius: 8, padding: '8px 12px', fontSize: 13, borderLeft: '3px solid #eab308' }}>{r.correccion}</div>
            </div>
          )}

          {/* Checkboxes uso de este ejemplo */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600, color: r.usar_ejemplo ? '#16a34a' : '#6b7280', userSelect: 'none' }}>
                <input
                  type="checkbox"
                  checked={!!r.usar_ejemplo}
                  onChange={() => toggleEjemplo(r.id)}
                  style={{ width: 15, height: 15, cursor: 'pointer', accentColor: '#16a34a' }}
                />
                ✅ Usar como referencia
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600, color: r.responder_siempre ? '#d97706' : '#6b7280', userSelect: 'none' }}>
                <input
                  type="checkbox"
                  checked={!!r.responder_siempre}
                  onChange={() => toggleResponderSiempre(r.id)}
                  style={{ width: 15, height: 15, cursor: 'pointer', accentColor: '#d97706' }}
                />
                ⚡ Responder siempre
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600, color: r.no_responder ? '#dc2626' : '#6b7280', userSelect: 'none' }}>
                <input
                  type="checkbox"
                  checked={!!r.no_responder}
                  onChange={() => toggleNoResponder(r.id)}
                  style={{ width: 15, height: 15, cursor: 'pointer', accentColor: '#dc2626' }}
                />
                🚫 No responder este tipo
              </label>
            </div>

            {editando === r.id ? (
              <div style={{ width: '100%' }}>
                <textarea
                  value={correccion}
                  onChange={e => setCorreccion(e.target.value)}
                  placeholder="Escribe cómo debería haber respondido..."
                  rows={3}
                  style={{ width: '100%', padding: 8, borderRadius: 6, border:`1px solid ${theme.borderStrong}`, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }}
                />
                <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                  <button onClick={() => darFeedback(r.id, 'corregida', correccion)} style={{ padding: '6px 14px', borderRadius: 6, background: '#eab308', color: '#1c1400', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Guardar corrección</button>
                  <button onClick={() => setEditando(null)} style={{ padding: '6px 14px', borderRadius: 6, background:theme.surface2, color:theme.body, border: 'none', cursor: 'pointer', fontSize: 12 }}>Cancelar</button>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => darFeedback(r.id, 'buena', null)} style={{ padding: '5px 14px', borderRadius: 6, border: `1px solid ${pastelBtn(theme,'green').border.split(' ').pop()}`, background: r.feedback === 'buena' ? '#16a34a' : pastelBtn(theme,'green').background, color: r.feedback === 'buena' ? '#fff' : pastelBtn(theme,'green').color, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>✅ Buena</button>
                <button onClick={() => darFeedback(r.id, 'mala', null)} style={{ padding: '5px 14px', borderRadius: 6, border: `1px solid ${pastelBtn(theme,'red').border.split(' ').pop()}`, background: r.feedback === 'mala' ? '#dc2626' : pastelBtn(theme,'red').background, color: r.feedback === 'mala' ? '#fff' : pastelBtn(theme,'red').color, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>❌ Mala</button>
                <button onClick={() => { setEditando(r.id); setCorreccion(r.correccion || ''); }} style={{ padding: '5px 14px', borderRadius: 6, border: `1px solid ${pastelBtn(theme,'amber').border.split(' ').pop()}`, background: r.feedback === 'corregida' ? '#d97706' : pastelBtn(theme,'amber').background, color: r.feedback === 'corregida' ? '#fff' : pastelBtn(theme,'amber').color, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>✏️ Corregir</button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
